import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=651b11b4&"
import script from "./ProductEdit.vue?vue&type=script&lang=ts&"
export * from "./ProductEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProductEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports